export const DEFAULT_LAST_TRANSACTION_ID = 0;
export const NOTE_MAX_LENGTH = 255;
